import moment from '../date/moment';

export const formatDateTimeToString = function (
  dateTime: Date | string | null | undefined,
  format: string = 'DD.MM.YYYY HH:mm',
  fromUtc: boolean = true
) {
  if (dateTime) {
    return fromUtc
      ? moment.utc(dateTime).locale('ru').format(format)
      : moment(dateTime).locale('ru').format(format);
  }
  return '';
};
